<template>
  <v-container fluid fill-height dark class="message-container animated fadeInDown">
    <v-layout align-content-center text-center row>
      <v-flex xs12>
        <h2 class="text-h5 font-weight-bold message-title">{{ $t("view.login.forgetPwdMessage.titleFirstPart") }} {{ nombre }}{{ $t("view.login.forgetPwdMessage.titleSecondPart") }}</h2>
      </v-flex>
      <v-flex xs12>
        <p class="message-instruction">
          {{ $t("view.login.forgetPwdMessage.instructions") }}
        </p>
      </v-flex>
      <v-flex xs12>
        <div class="sk-spinner sk-spinner-circle message-spinner">
          <div class="sk-circle1 sk-circle" />
          <div class="sk-circle2 sk-circle" />
          <div class="sk-circle3 sk-circle" />
          <div class="sk-circle4 sk-circle" />
          <div class="sk-circle5 sk-circle" />
          <div class="sk-circle6 sk-circle" />
          <div class="sk-circle7 sk-circle" />
          <div class="sk-circle8 sk-circle" />
          <div class="sk-circle9 sk-circle" />
          <div class="sk-circle10 sk-circle" />
          <div class="sk-circle11 sk-circle" />
          <div class="sk-circle12 sk-circle" />
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "ForgetPwdMessageModule"
  , data() {
    return { nombre: "" };
  }
  , head: {
    title: function () {
      return {
        inner: this.$t("view.login.forgetPwd.title")
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    if (this.$route.params.username) {
      const { username } = this.$route.params;
      this.nombre = username;
      setTimeout(() => this.$router.push({ name: "SignIn" }), 3000);
    } else {
      this.$router.push("/401Unauthorized");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.message-container {
  background-color: #2f4050;
}
.message-title {
  margin-bottom: 10px;
  color: white;
}
.message-instruction {
  margin-bottom: 30px;
  color: #c4c4c4;
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/ForgetPwdMessage.vue